import Vue from 'vue'
import Router from 'vue-router'
import menuModule from 'vuex-store/modules/menu'
Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  hashbang: false,
  linkActiveClass: 'is-active',
  mode: 'history',
  base: __dirname,
  routes: [
    {
      name: 'Home',
      path: '/',
      component: require('../views/Home')
    },
    {
      name: 'Login',
      path: '/login',
      component: require('../views/auth/Login')
    },
    {
      name: 'Upload',
      path: '/upload',
      component: require('../views/admin/Upload'),
      meta: {auth: true}
    },
    {
      name: 'MyFiles',
      path: '/myfiles',
      component: require('../views/admin/MyFiles'),
      meta: {auth: true}
    },
    {
      name: 'Add Users',
      path: '/userhandler',
      component: require('../views/admin/HandleUsers'),
      meta: {auth: 'admin'}
    },
    {
      name: 'File Info',
      path: '/file/:fileid',
      component: require('../views/FileInfo')
    },
    {
      name: 'File Edit',
      path: '/edit/:fileid',
      component: require('../views/FileEdit')
    },
    {
      name: 'URL Shortner',
      path: '/shorturl',
      component: require('../views/URLShortner')
    },
    {
      name: 'DMCA',
      path: '/dmca',
      component: require('../views/DMCA')
    },
    {
      name: 'TOC',
      path: '/toc',
      component: require('../views/TOC')
    },
    ...generateRoutesFromMenu(menuModule.state.items),
    {
      path: '*',
      redirect: '/'
    }
  ]
})

// Menu should have 2 levels.
function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    if (!item.component) {
      generateRoutesFromMenu(item.children, routes)
    }
  }
  return routes
}



// WEBPACK FOOTER //
// ./client/router/index.js